import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=c4bef57c&scoped=true"
import script from "./couponDetail.vue?vue&type=script&lang=js"
export * from "./couponDetail.vue?vue&type=script&lang=js"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=c4bef57c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bef57c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4bef57c')) {
      api.createRecord('c4bef57c', component.options)
    } else {
      api.reload('c4bef57c', component.options)
    }
    module.hot.accept("./couponDetail.vue?vue&type=template&id=c4bef57c&scoped=true", function () {
      api.rerender('c4bef57c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/couponDetail.vue"
export default component.exports